import angular from 'angular'
import React from 'react'
import ReactDOM from 'react-dom'

import LinkListSubtypesConfiguration from '~/reactapp/Settings/LinkListSubtypesConfiguration'

const newTemplateId = 'react-LinkListSubtypesConfiguration'

function Link(scope, el) {
  const rootEl = el[0]

  scope.$on('$destroy', () => ReactDOM.unmountComponentAtNode(rootEl))

  scope.vm.render = (props) => {
    ReactDOM.render(<LinkListSubtypesConfiguration {...props} />, rootEl)
  }
}

function Controller() {
  const handleChange = (subtypeLists) => {
    this.onChange({ subtypeLists })
  }
  this.$onChanges = () => {
    this.render &&
      this.companySettings &&
      this.render({
        linkListSubtypes: this.companySettings.linkListSubtypes || [],
        linkSubtypes: this.companySettings.linkSubtypes || [],
        onChange: handleChange,
      })
  }
}

function directive() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template: `<div id="${newTemplateId}"/>`,
    scope: {
      companySettings: '<',
      onChange: '&',
    },
    controller: Controller,
    link: Link,
  }
}

export default angular
  .module('ellipsis.linkListSubtypesConfiguration', [])
  .directive('linklistsubtypesConfiguration', directive)
